import React, { useState, useRef,useEffect} from 'react';
import SeveritySelector from './SeveritySelector';
import MultiSelectFilter from './MultiSelectFilter';
import './styles/panelFiltros.css';
import { lang } from '../../generales/traduction';
import { useFetch } from '../../../hooks/useFetch';
import { capitalizeFirstLetter } from '../../../utils/utils';
import Action from '../../Action';
import SelectorAdmin from '../../SelectorAdmin';
import MultiSelector from '../../MultiSelector';
import { ta } from 'date-fns/locale';
import { set } from 'date-fns';
import { se } from 'date-fns/locale';
// import { lang } from '../../generales/traduction';
const FilterPanel = ({ isOpen,
  statusFilter,
  techFilter,
    serviceFilter,
    brandFilter,
    groupFilter,
    subgroupFilter,
    severityFilter,
    zoneFilter,tipoFilter,
    setTechFilter,
    setServiceFilter,
    setBrandFilter,
    setGroupFilter,
    setSubGroupFilter,setTipoFilter,
    setSeverityFilter,
    setZoneFilter,
    setStatusFilter
    ,filters, onFilterChange,yourData,buscar_cis,setManttoData,ManttoData,handleShowPopup,setSearchTerm,languaje,mode,user,dataUsers,devices,server,setRegisterIsValid,groupSelected,setData,loading,setLoading,setError,setEditActive,editActive,closCreateCisModal}) => {
  const [isDragging, setIsDragging] = useState(false);
  // // console.log(window)
  const [position, setPosition] = useState({ x: -10, y: 50 }); // Posición inicial en la esquina superior derecha
  const offset = useRef({ x: 0, y: 0 });
  //   const togglePanel = () => {
  //     setIsOpen(!isOpen);
  //   };

  const handleClearFilters = () => {
    // Reset all filters to their initial state
    const defaultFilters = {
      searchTerm: '',
      severities: [],
      statuses: ['PROBLEMA'], // Default value from your HTML
      techs: [],
      groups: [],
      subgroups: [],
      zones: [],
      ack: null,
      ticket: null,
    };
    onFilterChange(defaultFilters);
  };
  // Función para iniciar el arrastre
  const handleMouseDown = (e) => {
    // Evita arrastrar si se hace clic en un elemento interactivo
    if (e.target.closest('button, input, .tag, .options-dropdown div')) {
      return;
    }
    
    setIsDragging(true);
    const panel = e.currentTarget;
    offset.current.x = e.clientX - panel.offsetLeft;
    offset.current.y = e.clientY - panel.offsetTop;
  };

  // Función para mover el panel
  const handleMouseMove = (e) => {
    if (!isDragging) return;
    
    var newX = e.clientX - offset.current.x;
    var newY = e.clientY - offset.current.y;
  if(newX>-10){
   newX=-10
  };
  if((newY+500)>window.innerHeight){
   newY=window.innerHeight-500
  }


   setPosition({ x: newX, y: newY });
  }
  // Función para detener el arrastre
  const handleMouseUp = () => {
    setIsDragging(false);
  };

  // Hook para agregar y remover los listeners del documento
  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    } else {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging]); // Se ejecuta cada vez que el estado de 'isDragging' cambia


  const obtenerFechaActualLocal = () => {
         const ahora = new Date();
         const anio = ahora.getFullYear();
         const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
         const dia = String(ahora.getDate()).padStart(2, '0');
         const horas = String(ahora.getHours()).padStart(2, '0');
         const minutos = String(ahora.getMinutes()).padStart(2, '0');
       
         return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
       };
  // console.log(groupSelected)
  const [loadingM,setLoadingM]=useState(false);
  const [IpValid,setIpValid]=useState(true)
  const [LatValid,setLatValid]=useState(true)
  const [LonValid,setLonValid]=useState(true)
  const [matchPassword,setMatchPassword]=useState(false)
  const [disabled,setDisabled]=useState(true)



  // console.log(dataUsers.data)

  // console.log(ManttoData)

  // const tec_list=useFetch('cassia/ci_elements/technologies','','','GET',server)
  const [msgError,setMsgError]=useState("")
  const [listSearchIP,setListSearchIP]=useState(false)
  // const dataCriticalities=useFetch('cassia/group_types','','','GET',server)
  // console.log(dataCriticalities)
  const dataBrands=useFetch('cassia/brands','','','GET',server)
  const [dataModels,setDataModels]=useState({
    data: [],
    loading: true,
    error: null})

  // const dataGroups=useFetch('cassia/host_groups/by_type/1','','','GET',server)//manda el id 1 para grupos
  const dataTechs=useFetch('cassia/tech_devices','','','GET',server)
  const dataGroups=useFetch('cassia/cis_v2/groups','','','GET',server)
  const dataZones=useFetch('cassia/host_groups/by_type/2','','','GET',server)//manda el id 2 para zonas  




  const changeMultiOption=(option,index,titulo)=>{
    let attr=""
    if(titulo=="techDevices"){
      setTechFilter(option)
    }
    if(titulo=="services_catalog"){
      setServiceFilter(option)
    }
    if(titulo=="groups_catalog"){
      setGroupFilter(option)
    }
    if(titulo=="subgroups_catalog"){
      setSubGroupFilter(option)
    }


    if(titulo=="zona"){
      setZoneFilter(option)
    }
    if(titulo=="Marcas"){
      setBrandFilter(option)
    }



    // setManttoData((prevState)=>{
    //     return {
    //         ...prevState,
    //         [attr]:option.map(item => item.value)
    //     }

    // })
  }
  // const [severityOptions ,setSeverityOptions] = useState([])

  const handleStatus = (option) => {
    let newSelection;
    if (statusFilter.includes(option)) {
      // Si la opción ya está seleccionada, la removemos del array.
      newSelection = statusFilter.filter((val) => val !== option);
    } else {
      // Si la opción no está seleccionada, la agregamos al array.
      newSelection = [...statusFilter, option];
    }
    // Llama a la función del padre para actualizar el estado.
    setStatusFilter(newSelection);
  };

  const handleTipo = (option) => {
     let newSelection;
    if (tipoFilter.includes(option)) {
      // Si la opción ya está seleccionada, la removemos del array.
      newSelection = tipoFilter.filter((val) => val !== option);
    } else {
      // Si la opción no está seleccionada, la agregamos al array.
      newSelection = [...tipoFilter, option];
    }
    // Llama a la función del padre para actualizar el estado.
    setTipoFilter(newSelection);
  };
  const handleSeverity = (option) => {
    let newSelection;
    if (severityFilter.includes(option)) {
      // Si la opción ya está seleccionada, la removemos del array.
      newSelection = severityFilter.filter((val) => val !== option);
    } else {
      // Si la opción no está seleccionada, la agregamos al array.
      newSelection = [...severityFilter, option];
    }
    // Llama a la función del padre para actualizar el estado.
    setSeverityFilter(newSelection);
  };
  return (
      <div>
        {/* <button onClick={togglePanel}>Filtros</button> */}
        {isOpen && (
          <div className="filter-panel "
          style={{ 
              left: `${position.x}px`, 
              top: `${position.y}px`,
              cursor: isDragging ? 'grabbing' : 'grab', // Cambia el cursor
              zIndex: 5, // Asegura que el panel esté por encima de otros elementos
              
            }}
            onMouseDown={handleMouseDown}>
              
            <div className="form-GS-box"> 
                                      
                                      
                                      
                                      
                                     
                                     <div className="user-box-GS"  style={{height:'20%'}}>
                                      
                                          <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['severidad'])}</label>
                                          <div class="severity-selector" id="severidad-selector">
                  <button class={"severity-btn "+(severityFilter.includes(1)?'active':'')} data-value="1" onClick={() => handleSeverity(1)}>1</button>
                  <button class={"severity-btn "+(severityFilter.includes(2)?'active':'')} data-value="2" onClick={() => handleSeverity(2)}>2</button>
                  <button class={"severity-btn "+(severityFilter.includes(3)?'active':'')} data-value="3" onClick={() => handleSeverity(3)}>3</button>
                  <button class={"severity-btn "+(severityFilter.includes(4)?'active':'')} data-value="4" onClick={() => handleSeverity(4)}>4</button>
                  <button class={"severity-btn "+(severityFilter.includes(5)?'active':'')} data-value="5" onClick={() => handleSeverity(5)}>5</button>
              </div>
                                      </div>
                                      
                                      <div className="user-box-GS"  style={{height:'20%'}}>
                                     
                                          <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['eventoValido'])}</label>
                                          <div class="severity-selector" id="status-selector">
                  <button class={"severity-btn "+(statusFilter.includes(1)?'active':'')} data-value="PROBLEMA" onClick={() => handleStatus(1)}>{capitalizeFirstLetter(lang[languaje]['valido'])}</button>
                  <button class={"severity-btn "+(statusFilter.includes(0)?'active':'')} data-value="RESUELTO"onClick={() => handleStatus(0)}>{capitalizeFirstLetter(lang[languaje]['falsoPositivo'])}</button>
              </div>
                                      </div>
                                      <div className="user-box-GS " style={{height: 'auto',minHeight: '20%'}}>
                                          {
                                              (dataTechs.loading)?<p style={{color:'var(--txt-color)'}}> {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])} . . .</p>:
                                              <MultiSelector placeholder={capitalizeFirstLetter(lang[languaje]['seleccionarTecnologia'])} opGeneral={true} txtOpGen={''}  opt_de={techFilter.map(item => item.id)} origen={'Admin'} data={dataTechs.data.data}   loading={dataTechs.loading}  titulo='techDevices' selectFunction={changeMultiOption} index={0}></MultiSelector>
                                          }
                                          <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['tecnologia'])}</label>   
                                      </div>
                                      {/* <div className="user-box-GS " style={{height: 'auto',minHeight: '20%'}}>
                                          {
                                              (services_catalog.loading)?<p style={{color:'var(--txt-color)'}}> {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])} . . .</p>:
                                              <MultiSelector placeholder={'Seleccionar nivel...'} opGeneral={true} txtOpGen={''}  opt_de={serviceFilter.map(item => item.id)} origen={'Admin'} data={services_catalog.data.data}   loading={services_catalog.loading}  titulo='services_catalog' selectFunction={changeMultiOption} index={0}></MultiSelector>
                                          }
                                          <label className='label-GS'>{'Servicios'}</label>   
                                      </div> */}
                                     
                                      {/* <div className="user-box-GS"  style={{height: 'auto',minHeight: '20%'}}>
                                      
                                          {
                                              (dataGroups.loading)?<p style={{color:'var(--txt-color)'}}> {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])} . . .</p>:
                                              <MultiSelector placeholder={'Seleccionar nivel...'} opGeneral={false} txtOpGen={''}  opt_de={groupFilter.map(item => item.id)} origen={'Admin'} 
                                              data={dataGroups.data.data.filter(item => item.type === "GRUPO").map(item => ({
                                                  ...item,
                                                  name: `${item.name} `
                                                }))}   
                                                loading={dataGroups.loading}  titulo='groups_catalog' selectFunction={changeMultiOption} index={0}></MultiSelector>
                                                                                      }
                                          <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['grupos'])}</label>
                                          
                                      </div> */}
                                      {/* <div className="user-box-GS"  style={{height: 'auto',minHeight: '20%'}}>
                                     
                                          {
                                              (dataGroups.loading)?<p style={{color:'var(--txt-color)'}}> {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])} . . .</p>:
                                              <MultiSelector placeholder={'Seleccionar nivel...'} opGeneral={false} txtOpGen={''}  opt_de={groupFilter.map(item => item.id)} origen={'Admin'} 
                                              data={dataGroups.data.data.filter(item => {
      const isSubgrupo = item.type === "SUBGRUPO";

      // si arr está vacío, no aplicamos filtro de parent_id
      if (groupFilter.length === 0) return isSubgrupo;

      // si arr tiene valores, filtramos por parent_id
      return isSubgrupo && groupFilter.some(a => a.value === item.parent_id);
    }).map(item => ({
                                                  ...item,
                                                  name: `${item.name} (${item.parent_name})`
                                                }))}   
                                                loading={dataGroups.loading}  titulo='subgroups_catalog' selectFunction={changeMultiOption} index={0}></MultiSelector>
                                                                                      }
                                          <label className='label-GS  '>{'Subgrupos'}</label>
                                          
                                      </div> */}
                                      <div className="user-box-GS"  style={{height: 'auto',minHeight: '20%'}}>
                                      {
                                              (dataZones.loading)?<p style={{color:'var(--txt-color)'}}> {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])} . . .</p>:
                                              <MultiSelector placeholder={capitalizeFirstLetter(lang[languaje]['seleccionarZona'])} opGeneral={true} txtOpGen={''}  opt_de={zoneFilter.map(item => item.id)} origen={'Admin'} data={dataZones.data.data}   loading={dataZones.loading}  titulo='zona' selectFunction={changeMultiOption} index={0}></MultiSelector>
                                          }
                                          <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['zona'])+" / "+capitalizeFirstLetter(lang[languaje]['municipio'])}</label>
                                          
                                      </div>
                                      <div className="user-box-GS"  style={{height:'20%'}}>
                                      {/* <input required name="location_lat" maxlength={9} placeholder=' valores >= -90  y <= 90°     ejemplo:(20.000)' type="text" value={location_lat}
                                      onChange={handleChange}  /> */}
                                          <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['tipo'])}</label>
                                           <div class="severity-selector" id="Tipo-selector" >
                  <button class={"severity-btn "+(tipoFilter.includes('workflow')?'active':'')} data-value="true" onClick={() => handleTipo('workflow')}>WorkFlow</button>
                  <button class={"severity-btn "+(tipoFilter.includes('correlation')?'active':'')} data-value="false" onClick={() => handleTipo('correlation')}>{capitalizeFirstLetter(lang[languaje]['correlacion'])}</button>
                   {/* <button class={"severity-btn "+(tipoFilter.includes('camera_sd')?'active':'')} data-value="false" onClick={() => handleTipo('camera_sd')}>Camera_SD</button>
                    <button class={"severity-btn "+(tipoFilter.includes('reset')?'active':'')} data-value="false" onClick={() => handleTipo('reset')}>Reset</button> */}
              </div>
               
                                      </div>
                                      {/* <div className="user-box-GS"  style={{height:'10%'}}>
                                    
                                           <div class="severity-selector" id="Tipo-selector" >
                 <button class={"severity-btn "+(tipoFilter.includes('camera_sd')?'active':'')} data-value="false" onClick={() => handleTipo('camera_sd')}>Camera_SD</button>
                    <button class={"severity-btn "+(tipoFilter.includes('reset')?'active':'')} data-value="false" onClick={() => handleTipo('reset')}>Reset</button>
              </div>
               
                                      </div> */}
                                      {/* <div className="user-box-GS"  style={{height:'20%'}}>
                                    
                                          <label className='label-GS  '>{'Acuse (Ack)'}</label>
                                          <div class="severity-selector" id="ack-selector">
                  <button class={"severity-btn "+(ackFilter.includes(1)?'active':'')}  data-value="true" onClick={() => handleAck(1)}>Con Ack</button>
                  <button class={"severity-btn "+(ackFilter.includes(0)?'active':'')}  data-value="false" onClick={() => handleAck(0)}>Sin Ack</button>
              </div>
                                      </div> */}
                                     
                                      
                                     
                                     
                                     
                                      
                                      
                                     
                                     
                                     
                                     
                                     
                                      
                                      
                                      
                                  </div> 
          </div>
        )}
      </div>
    );
};

export default FilterPanel;